import { topicsData } from '@/mocks/homeData';

const colorMap: Record<string, { bg: string; text: string; hover: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', hover: 'hover:bg-primary-200' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', hover: 'hover:bg-accent-200' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-800', hover: 'hover:bg-secondary-200' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <span className="text-xs font-semibold text-secondary-500 uppercase tracking-wider">🏷️ TOPICS</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">热门话题</h2>
          <p className="text-sm text-foreground-500 mt-1">探索不同风格与类型的漫画世界，找到你的专属口味</p>
        </div>

        <div className="flex flex-wrap gap-3">
          {topicsData.map((topic) => {
            const c = colorMap[topic.color] || colorMap.primary;
            return (
              <a
                key={topic.name}
                href="#"
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full ${c.bg} ${c.text} ${c.hover} transition-colors duration-200 cursor-pointer no-underline text-sm font-medium`}
              >
                <span>{topic.name}</span>
                <span className="text-xs opacity-60">{topic.count}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}